(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("THREE"));
	else if(typeof define === 'function' && define.amd)
		define(["THREE"], factory);
	else if(typeof exports === 'object')
		exports["ENABLE3D"] = factory(require("THREE"));
	else
		root["ENABLE3D"] = factory(root["THREE"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 